import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import Typewriter from './Typewriter';

const Flagship = () => {
  return (
    <section className="py-24 bg-charcoal border-y border-white/5 relative overflow-hidden">
      {/* Background Glow */}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 w-1/3 h-full bg-neon-cyan/5 blur-[100px] pointer-events-none"></div>
      
      <div className="container mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-12 items-center">
          {/* Content Side */}
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="lg:w-1/2"
          >
            <div className="flex items-center gap-2 mb-4 font-mono">
              <span className="w-2 h-2 bg-neon-cyan rounded-full animate-pulse"></span>
              <Typewriter text="FLAGSHIP PROJECT" className="text-neon-cyan text-sm uppercase tracking-widest" />
            </div>

            <div className="relative scanline-overlay inline-block mb-6">
              <h2 className="text-4xl md:text-6xl font-orbitron font-bold text-white leading-tight">
                <Typewriter text="OMNI-AGENT" delay={400} /> <br />
                <Typewriter text="ARCHITECTURE" delay={1000} />
              </h2>
            </div>
            
            <Typewriter 
              as="p"
              text="A scalable multi-agent system designed to handle complex customer support workflows autonomously. By orchestrating specialized LLM agents, Omni-Agent reduced resolution times by 60% for enterprise clients."
              delay={1800}
              speed={20}
              className="text-gray-300 text-lg mb-8 leading-relaxed block"
            />

            <div className="grid grid-cols-2 gap-6 mb-10">
              <div>
                <h4 className="text-white font-bold font-orbitron mb-2">ROLE</h4>
                <p className="text-gray-400 text-sm font-mono">Lead Architect & Engineer</p>
              </div>
              <div>
                <h4 className="text-white font-bold font-orbitron mb-2">STACK</h4>
                <p className="text-gray-400 text-sm font-mono">Python, OpenAI API, Redis, Docker</p>
              </div>
            </div>

            <button className="px-8 py-3 border border-white text-white font-orbitron font-bold hover:bg-white hover:text-black transition-all uppercase tracking-wider">
              Read Deep Dive
            </button>
          </motion.div>

          {/* Visual Side */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="lg:w-1/2 w-full"
          >
            <div className="relative aspect-video bg-black border border-white/10 rounded-sm overflow-hidden group">
              <div className="absolute inset-0 bg-gradient-to-br from-gray-900 to-black p-6 flex flex-col justify-between">
                <div className="flex justify-between items-center border-b border-white/10 pb-4">
                  <div className="flex gap-2">
                    <div className="w-3 h-3 rounded-full bg-red-500"></div>
                    <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                    <div className="w-3 h-3 rounded-full bg-green-500"></div>
                  </div>
                  <div className="text-xs font-mono text-gray-500">omni_agent_core.py</div>
                </div>
                
                <div className="space-y-3 font-mono text-xs md:text-sm text-green-400/80">
                  <p className="flex items-center gap-1">
                    {">"} <Typewriter text="Initializing Agent Swarm..." speed={30} delay={1000} />
                  </p>
                  <p className="flex items-center gap-1">
                    {">"} <Typewriter text="Connection established: Node [Alpha]" speed={30} delay={2000} />
                  </p>
                  <p className="flex items-center gap-1">
                    {">"} <Typewriter text="Loading Context Vectors..." speed={30} delay={3000} /> 
                    <span className="text-white ml-auto">DONE</span>
                  </p>
                  <p className="flex items-center gap-1">
                    {">"} <Typewriter text='Analyzing Intent: "Refund Processing"' speed={30} delay={4000} />
                  </p>
                  <p className="animate-pulse">{">"} Executing Workflow...</p>
                </div>

                <div className="mt-4 p-4 bg-white/5 border border-white/10 rounded">
                  <div className="h-2 w-1/3 bg-white/20 rounded mb-2"></div>
                  <div className="h-2 w-2/3 bg-white/20 rounded"></div>
                </div>
              </div>
              {/* Overlay Flash */}
              <div className="absolute inset-0 bg-neon-cyan/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Flagship;